module.exports = __webpack_public_path__ + "img/logo.cd95c421.svg";